import { Skeleton } from '@chakra-ui/react';

export const CreatorListItemSkeleton: React.FC = () => {
  return (
    <Skeleton
      startColor="primary.50"
      endColor="primary.100"
      borderRadius="md"
      width="100%"
      height={10}
    />
  );
};
